<template>
    <section>
        <div class="cabinet-history__container">
            <div class="cabinet-history__details-btn" @click="toggleBtn">
                <span ref="toggleInfo">+</span>
            </div>
            <div class="cabinet-history__order-info">
                <div class="cabinet-history__order-number">
                    {{ status }} {{ id }}
                </div>
                <div class="cabinet-history__order-date">
                    {{ date }}
                </div>
            </div>
            <div class="cabinet-history__goods">
                <div v-if="items" class="cabinet-history__goods-number">
                    {{ items.length }}
                </div>
                <div v-if="width <= 990" class="cabinet-history__dashed-line"></div>
                <div class="cabinet-history__goods-description">
                    {{ nameCount }}
                </div>
            </div>
            <div class="cabinet-history__price">
                <div v-if="prices.printPrice" class="cabinet-history__price-number">
                    {{ prices.printPrice.value }}
                </div>
                <div v-if="width <= 990" class="cabinet-history__dashed-line"></div>
                <div class="cabinet-history__price-description">
                    {{ summMessage }}
                </div>
            </div>
            <div v-if="items" class="cabinet-history__img-list">
                <img v-for="(item, i) in items.slice(0, 3)" :src="item.picture.src" :alt="item.picture.alt" />
            </div>
            <div class="cabinet-history__status" :style="'color:'+statusColor">
                {{ printStatus }}
<!--                <span class="cabinet-history__done">-->
<!--                    Виконаний-->
<!--                </span>-->
<!--                <span class="cabinet-history__canceled">-->
<!--                    Скасований-->
<!--                </span>-->
            </div>
        </div>
        <SlideUpDown :modelValue="active">
            <div class="history-details">
                <div class="history-details__items-list">
                    <div class="history-details__item" v-for="item in items">
                        <div class="history-details__item-img">
                            <a :href="item.detailPage" v-if="item.picture">
                                <img :src="item.picture.src" :alt="item.picture.alt" :width="item.picture.width" :height="item.picture.height" />
                            </a>
                        </div>
                        <div class="history-details__title">
                            <div class="history-details__name">
                                <a :href="item.detailPage">
                                    {{ item.name }}
                                </a>
                            </div>
                            <div class="history-details__size">
                                <span v-if="item.displayProperties" v-for="displayProperty in item.displayProperties">
                                    {{displayProperty.name}}: {{displayProperty.value}}
                                </span>
                                <span v-if="item.offer">
                                <span v-if="item.offer.displayProperties" v-for="displayProperty in item.offer.displayProperties">
                                    {{displayProperty.name}}: {{displayProperty.value}}
                                </span>
                                </span>
                            </div>
                        </div>
                        <div class="history-details__article" v-if="item.id">
                            арт. {{ item.id }}
                        </div>
                        <div class="history-details__quantity">
                            {{ item.count }} шт
                        </div>
                        <div class="history-details__price-number">
                            {{ item.price.price }} грн
                        </div>
                    </div>
                </div>
                <div class="history-details__container-info">
                    <div class="history-details__main">
                        <div class="history-details__main-list">
                            <div class="history-details__row">
                                {{ "Оплата" }} <span>{{ paySystem.printName }}</span>
                            </div>
                            <div class="history-details__row">
                                {{ "Доставка" }} <span>{{ delivery.printName }}</span>
                            </div>
                            <div class="history-details__row" v-for="props in properties">
                                {{ props.name }} <span>{{ props.value }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="history-details__price">
                        <div class="history-details__price-list">
                            <div v-for="(price, key) of prices">
                                <div class="history-details__price-row" v-if="!['printCount', 'totalDiscount'].includes(key)">
                                    {{ price.title }} <span class="details-price"> {{ price.value }} </span>
                                </div>
                            </div>

                            <div class="history-details__price-row">
                                {{ "Доставка" }} <span class="details-price"> {{ delivery.price?.printPrice }} </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="width <= 990" class="hide-details" @click="toggleBtn">
                        <span>
                            <DefProgramMe tag="span">Згорнути деталі</DefProgramMe>
                        </span>
                    </div>

                </div>
            </div>
        </SlideUpDown>
        <div class="cabinet-history__bottom-line"></div>
    </section>
</template>

<script>
import DefProgramMe from "../def/DefProgramMe/DefProgramMe";
export default {
    name: 'cabinet-history-item',
    selector: '.cabinet-history-item',
    props: {
        result: {
            type: Object,
        },
        delivery: {
            type: Object,
        },
        items: {
            type: Array
        },
        prices: {
            type: Object
        },
        paySystem: {
            type: Object
        },
        properties: {
            type: Array
        },
        statusColor: {
            type: String
        },
        printStatus: {
            type: String
        },
        status: {
            type: String
        },
        id: {
            type: Number
        },
        date: {
            type: String
        },
        nameCount: {
            type: String
        },
        summMessage: {
            type: String
        },
    },
    components: {
        DefProgramMe,
    },
    data() {
        return {
            active: false,
            toggleInfo: true,
            width: window.innerWidth
        }
    },
    mounted(){
        if (this.width <= 990){
            this.$refs.toggleInfo.innerHTML = 'Деталі'
        }
    },
    methods: {
        toggleBtn() {
            this.active = !this.active
            if (this.toggleInfo && this.width > 991) {
                this.$refs.toggleInfo.innerHTML = '-'
                this.toggleInfo = false
            } else if (this.width > 991){
                this.$refs.toggleInfo.innerHTML = '+'
                this.toggleInfo = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.line-dashed{

}

.cabinet-history {
    &__container {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: 9% 17% 12% 16% 36% 10%;
        padding-top: rem(32);
        padding-bottom: rem(32);
        max-height: rem(100);
        max-width: rem(1004);
        @media (max-width: 991px) {
            grid-template-rows: rem(46) rem(24) rem(34) rem(60);
            grid-template-columns: 1fr 1fr;
            grid-template-areas:
                'orderInfo status'
                'goods goods'
                'price price'
                'imgList detailsBtn';
            max-height: 100%;
            padding-bottom: 0;
        }
    }

    &__details-btn {
        max-height: 100%;
        //padding: rem(7) 0 0 rem(39);
        cursor: pointer;
        font-size: rem(24);
        @media (max-width: 991px){
            span{
                border-bottom: 1px dashed #757575
            }
            grid-area: detailsBtn;
            text-align: right;
            font-weight: 500;
            font-size: 12px;
            line-height: 115%;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #757575;
        }
    }

    &__order-number, &__goods-number, &__price-number {
        font-style: normal;
        font-weight: 500;
        font-size: rem(16);
        line-height: 110%;
        color: #191918;
        margin-bottom: rem(4);

    }

    &__price-number{
        @media (max-width: 991px) {
            order: 3;
        }
    }

    &__goods-number{
        @media (max-width: 991px) {
            order: 3;
            padding-left: rem(5);
        }
    }

    &__dashed-line{
        height: 11px;
        width: 89%;
        border-bottom: 1px dotted #757575;
    }


    &__order-date {
        text-transform: uppercase;
    }

    &__goods{
        @media (max-width: 991px){
            grid-area: goods;
            display: flex;
            justify-content: space-between;
        }
    }

    &__order-info{
        @media (max-width: 991px){
            grid-area: orderInfo;
        }

    }

    &__price{
    @media (max-width: 991px) {
            grid-area: price;
            display: flex;
            justify-content: space-between;
        }
    }

    &__price-number{
        text-align: right;
        min-width: rem(72);
        margin-left: rem(10);
        @include point-lg{
            text-align: unset;
        }
    }

    &__order-date, &__goods-description, &__price-description {
        font-style: normal;
        font-weight: 500;
        font-size: rem(12);
        line-height: 115%;
        letter-spacing: 0.1em;
        color: #757575;
    }
    &__goods-description, &__price-description{
        @media (max-width: 991px) {
            order: -1;
        }
    }
    &__price-description{
        min-width: rem(108);
    }

    &__status {
        padding-top: rem(11);
        font-style: normal;
        font-weight: 500;
        font-size: rem(12);
        line-height: 115%;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #757575;
        @media (max-width: 991px) {
            grid-area: status;
            text-align: right;
        }

    }
    &__done{
        color: var(--text-colour-secondary);
    }

    &__canceled{
        color: #C80024;
    }

    &__img-list {
        display: flex;
        @media (max-width: 991px) {
            grid-area: imgList;
            padding-bottom: 24px;
        }
        img {
            width: rem(36);
            height: rem(36);
            margin-right: rem(24);
        }
    }

    &__bottom-line {
        height: rem(1);
        background-color: #DFDFDF;
        max-width: rem(940);
        margin: 0 auto;
    }

    .history-details {
        max-width: rem(880);
        background: #F7F8F9;
        margin: 0 auto;
        padding-bottom: rem(16);

        &__items-list {
            padding: rem(16) rem(16) rem(4) rem(16);
            @media (max-width: 991px){
                padding: rem(16) rem(16) rem(0) rem(16);
            }
        }

        &__item {
            background-color: white;
            display: grid;
            grid-template-rows: 1fr;
            grid-template-columns: 12% 37% 22% 13% 16%;
            min-height: rem(88);
            max-width: rem(848);
            margin-bottom: rem(4);
            @media (max-width: 991px){
                padding: rem(12) 0;
                grid-template-rows: rem(64) rem(54);
                grid-template-columns: 33% 33% 33%;
                grid-template-areas:
                'imgList titleSize titleSize'
                'article quantity priceNumber';
            }
        }

        &__item-img {
            img {
                position: relative;
                top: rem(16);
                right: rem(8);
                display: block;
                width: rem(55);
                height: rem(55);
                margin: 0 auto;
                @media (max-width: 991px){
                    top: 0;
                    width: rem(40);
                    height: rem(40);
                }
            }
        }

        &__price-number {
            text-align: right;
            @media (max-width: 991px){
                grid-area: priceNumber;
            }
        }

        &__title {
            align-self: center;
            @media (max-width: 991px){
                grid-area: titleSize;
            }
        }

        &__name {
            width: rem(280);
            //height: rem(18);
            font-style: normal;
            font-weight: 500;
            font-size: rem(16);
            line-height: 115%;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: black;
            @media (max-width: 991px){
                width: 100%;
                height: 100%;
            }
            @media (max-width: 340px){
                font-size: rem(14);
            }
        }

        &__size {
            padding-top: rem(8);
            width: rem(195);
            height: rem(18);
            font-style: normal;
            font-weight: normal;
            font-size: rem(16);
            line-height: 110%;
            color: #757575;
            @media (max-width: 340px){
                font-size: rem(12);
            }
        }

        &__article, &__quantity {
            align-self: center;
            font-style: normal;
            font-weight: normal;
            font-size: rem(14);
            line-height: 100%;
            color: #757575;
        }

        &__article{
            @media (max-width: 991px){
                grid-area: article;
                text-align: center;
            }
            @media (max-width: 340px){
                font-size: rem(12);
            }
        }

        &__quantity {
            align-self: center;
            @media (max-width: 991px){
                grid-area: quantity;
                text-align: center;
            }
        }

        &__price-number {
            align-self: center;
            margin-right: rem(23);
            font-style: normal;
            font-weight: 500;
            font-size: rem(16);
            line-height: 110%;
            text-align: right;
            color: #191918;
        }

        &__container-info {
            display: flex;
            justify-content: center;
            @media (max-width: 991px){
                flex-direction: column;
                margin: 0 rem(16);
            }
        }

        &__main {
            width: 100%;
            background: #FFFFFF;
            margin-right: rem(4);
            margin-left: rem(16);
            @media (max-width: 991px){
                margin-left: 0;
                margin-bottom: rem(4);
                }
            }

        &__main-list {
            padding: rem(16) 0 rem(24) rem(16);
        }

        &__price {
            width: 100%;
            //height: rem(136);
            background: #FFFFFF;
            margin-right: rem(16);
        }

        &__row {
            padding-top: rem(8);
            font-style: normal;
            font-weight: normal;
            font-size: rem(14);
            line-height: 100%;
            color: #757575;
            display: flex;
            align-items: center;
            justify-content: space-between;
            @media (max-width: 340px){
                font-size: rem(12);
            }

            span {
                font-weight: 500;
                font-size: rem(14);
                line-height: 100%;
                color: #191918;
                margin-right: rem(24);
                width: 50%;
                text-align: right;
                word-break: break-all;
            }
        }

        &__price-list {
            padding: rem(24) rem(16);
        }

        &__price-row {
            padding-top: rem(8);
            font-style: normal;
            font-weight: normal;
            font-size: rem(14);
            line-height: 100%;
            color: #757575;

            span {
                float: right;
                padding-right: rem(24);
            }

            .details-price {
                font-weight: 500;
                font-size: rem(14);
                line-height: 100%;
                color: #191918;
            }

            .details-discount {
                font-weight: 500;
                font-size: rem(14);
                line-height: 100%;
                color: #C80024;
            }

            .details-delivery {
                font-weight: 500;
                font-size: rem(14);
                line-height: 100%;
                color: #618EAF;
            }

            .details-all-price {
                font-weight: 500;
                font-size: rem(18);
                line-height: 120%;
                color: #191918;
            }
        }
    }
    .hide-details{
        font-weight: 500;
        font-size: 12px;
        line-height: 115%;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #757575;
        cursor: pointer;
        padding-top: 24px;
        padding-bottom: 8px;
        span{
            border-bottom: 1px dashed #757575;
        }
    }
}

</style>